import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import ReactHtmlParser from 'react-html-parser';
import dompurify from 'dompurify';

import {
    TextField,
    InputAdornment,
    IconButton,
    Typography,
    Button,
    CircularProgress,
    Grid,
    Box
} from "@material-ui/core";

import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import NotificationImportantIcon from '@material-ui/icons/NotificationImportant';
import FloatingContainer from "src/shared_modules/veu-visitors-core/components/common/container/floatingContainer";
import LinkInText from "src/shared_modules/veu-visitors-core/components/common/link-in-text";

import {
    Translate
} from "src/shared_modules/i18n";

import {
    showPopover,
    hidePopover,
} from 'src/shared_modules/veu-visitors-core/actions/popovers';

import {
    validateCode
} from 'src/shared_modules/veu-visitors-core/actions/minievent-access';

import {
    redirectTo,
} from 'src/shared_modules/veu-visitors-core/actions/system';

import {
    currentLanguage,
} from "src/shared_modules/i18n";

class PopoverMiniEventAccess extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            canSend: false,
            isBusy: false,
            failed: false,
            fields: {
                password: ""
            },
            showPassword: false,
        }
    }

    componentDidMount() {
        this.clickSend = this.clickSend.bind(this);
    }

    componentWillUnmount() {
/* during un-mount the state is automatically set to undefined ;)
        this.state = {
            canSend: false,
            isBusy: false,
            failed: false,
            fields: {
                password: ""
            },
            showPassword: false,
        }
*/
    }

    validateInput(value) {
        // just not empty
        if (value === undefined || value === null || value.trim() === "")
            return false;

        return true;
    }

    handleInputChange(field, event) {
        event.preventDefault();
        // update the field value
        let fields = this.state.fields;
        let val = event.target.value;
        fields[field] = val;

        let canSend = true;

        if (!this.validateInput(fields["password"]))
            canSend = false;

        this.setState({
            fields: fields,
            canSend: canSend,
        });
    }

    togglePasswordVisibility() {
        this.setState({ showPassword: !this.state.showPassword });
    }

    async clickSend() {
        if (this.state.isBusy || !this.state.canSend)
            return;

        this.setState({
            isBusy: true,
            failed: false,
            showPassword: false,
        });

        await this.props.validateCode(this.props.user._id, this.state.fields["password"]);

        if (!this.props.minieventAccess.isCodeValid) {
            this.setState({
                failed: true,
                isBusy: false,
            });

        } else {
            this.setState({
                isBusy: false,
                fields: { password: "" },
                canSend: false
            });
            this.props.hidePopover("MiniEventLogin");
            if (this.props.event.isMiniEvent) {
              this.props.redirectTo( this.props.event.path +  "/tilesmenu" );
            }
            else {
              this.props.redirectTo( this.props.event.path + this.props.startloc.path );
            }
        }
    }

    renderContent() {
      const borderBoxProps = {
        bgcolor: 'background.paper',
        borderColor: '#e6e6e6',
        mb: 4,
        border: 1,
        padding: 2,
      };

      const sanitizer = dompurify.sanitize;

      let lang = currentLanguage().code2;
      let description = ReactHtmlParser(sanitizer(this.props.event.protectionPinText[lang]));

      return(<React.Fragment>
                <form onSubmit={(e) => { e.preventDefault(); }} >
                    {this.state.failed && <Box borderRadius={4} {...borderBoxProps} bgcolor="#e6e6e6">
                       <div className="minieventErrorDescriptionContainer">
                         <NotificationImportantIcon fontSize="large" />
                         <p className="minieventErrorDescription"><Translate>popovers.minieventAccess.error</Translate></p>
                       </div>
                    </Box>}
                    <Typography variant="h5" component="h1" color="primary">
                        <Translate>popovers.minieventAccess.title</Translate>
                    </Typography>
                    <Typography variant="body1" component="div" color="primary">
                        {description}
                    </Typography>
                    <br />
                    <TextField id="pin" key="minievent-pin"
                        autoFocus={true}
                        fullWidth
                        label={<Translate>popovers.minieventAccess.eventCode</Translate>}
                        variant="outlined"
                        value={this.state.fields["password"]}
                        onChange={(e) => { this.handleInputChange("password", e); }}
                        type={this.state.showPassword ? 'text' : 'password'}
                        InputProps={{
                            endAdornment:
                                <InputAdornment position="end">
                                    <IconButton aria-label="toggle password visibility"
                                        onClick={() => this.togglePasswordVisibility()}
                                        edge="end"
                                    >
                                        {this.state.showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                                    </IconButton>
                                </InputAdornment>
                        }}
                    />
                    <Box mt={6}>
                      <Grid container justify="flex-end">
                        <Button variant="contained"
                            size="large"
                            color="secondary"
                            onClick={() => { this.clickSend(); }}
                            disabled={!this.state.canSend}
                            type="submit"
                            endIcon={this.state.isBusy && <CircularProgress color="inherit" size={20} />}
                        >
                            <Translate>popovers.minieventAccess.send</Translate>
                        </Button>
                      </Grid>
                    </Box>
                </form>
            </React.Fragment>);
    }


    render() {
        if( !this.props.showMiniEventLogin )
            return(null);

        return (<FloatingContainer position="center"
                        width="sm"
                        fsSwitch="sm"
                        className="user"
                        modal
                        largeBottomPadding={this.props.event.hasUserlike}
                    >
                    { this.renderContent() }
            </FloatingContainer>);
    }
}

PopoverMiniEventAccess.propTypes = {
    showMiniEventLogin: PropTypes.bool,
    event: PropTypes.object,
    user: PropTypes.object,
    minieventAccess: PropTypes.object,
    startloc: PropTypes.object,
    currentLang : PropTypes.string,
};


/*
 * ---------------------------------------------------------------------
 * PopoverLogin Redux Container
 * ---------------------------------------------------------------------
 */
const mapStateToProps = ( state, ownProps ) => {
    return {
        showMiniEventLogin : state.popovers.showMiniEventLogin,
        event: state.event,
        user: state.user,
        minieventAccess: state.minieventAccess,
        startloc: state.system.startloc,
        currentLang : state.system.currentLang,
    };
};
const mapDispatchToProps = {
    showPopover,
    hidePopover,
    validateCode,
    redirectTo,
};

/*
 * ---------------------------------------------------------------------
 * Export the redux container
 * ---------------------------------------------------------------------
 */
export default connect(
        mapStateToProps,
        mapDispatchToProps
    )(PopoverMiniEventAccess);
